export const useDispatchEmail = () => {
  return (data: any) => {
    return fetch("/api/email", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
  };
};
